import { Facebook, Gesture, GitHub, Instagram, OpenInNew, X, YouTube } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../utils/firebase';
import { doc, getDoc } from 'firebase/firestore';

const InnerPromptMedia = ({ prompts }) => {
    // Icons Map
    const iconMap = {
        instagram: <Instagram />,
        facebook: <Facebook />,
        github: <GitHub />,
        twitter: <X />,
        youtube: <YouTube />,
        threads: <Gesture />
    };

    const [profile, setProfile] = useState(null);

    useEffect(() => {
        if (!prompts?.userId) return;

        const fetchProfile = async () => {
            try {
                const ref = doc(db, "users", prompts.userId);
                const snap = await getDoc(ref);

                if (snap.exists()) {
                    setProfile(snap.data());
                } else {
                    setProfile({ social: {} });
                }
            } catch (error) {
                console.error("Firebase Error:", error);
                setProfile({ social: {} });
            }
        };

        fetchProfile();
    }, [prompts?.userId]);


    // Loading state
    if (!profile) return <p style={{ color: "#fff" }}>Loading...</p>;

    // Check if there are any valid social links to show
    const hasSocialLinks = profile.social && 
        Object.values(profile.social).some(link => link && link.trim() !== "");

    if (!hasSocialLinks) return null; 

    return (
        <div className="user-info">
            <p className="__title-kle">Social Media</p>
            <ul>
                {Object.keys(profile.social)
                    .filter((key) => profile.social[key] && profile.social[key].trim() !== "")
                    .map((key) => (
                        <Link 
                            to={profile.social[key]} 
                            target="_blank" 
                            key={key} 
                            className="completed"
                            rel="noreferrer"
                        >
                            <span> {iconMap[key] || <OpenInNew />} </span>
                        </Link>
                    ))
                }
            </ul>
        </div>
    );
}

export default InnerPromptMedia;